module.exports = __webpack_public_path__ + "img/strength.0d48ab3c.svg";